import { useField } from 'vee-validate';
import NIPField from './NIPField.vue';
import EmployerCompanyName from './EmployerCompanyName.vue';
import Select from '../../ui/Select.vue';
import YourRoleInWork from './YourRoleInWork.vue';


export default {
  __name: 'SelectEmployerField',
  setup(__props, { expose }) {
  expose();

const { value, setValue, errorMessage } = useField('employerType');

const options = [
    {
        id: 'Pracownik - osoba cywilna',
        title: 'Pracownik - osoba cywilna',
    },
    {
        id: 'Student / uczeń',
        title: 'Student / uczeń',
    },
    {
        id: 'Pracownik służb mundurowych',
        title: 'Pracownik służb mundurowych',
    },
    {
        id: 'Pracownik w firmie zagranicznej',
        title: 'Pracownik w firmie zagranicznej',
    },
];

const __returned__ = { value, setValue, errorMessage, options, get useField() { return useField }, NIPField, EmployerCompanyName, Select, YourRoleInWork }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}